export const L10N = {
  ACTION_LOGIN: { id: 'common.action.login', defaultMessage: '     ' },
  LABEL_PROPERTY_TYPE: { id: 'common.label.property_type', defaultMessage: '' },
};
